import { render, staticRenderFns } from "./InputEvent.vue?vue&type=template&id=2b0176cc&scoped=true"
import script from "./InputEvent.vue?vue&type=script&lang=js"
export * from "./InputEvent.vue?vue&type=script&lang=js"
import style0 from "./InputEvent.vue?vue&type=style&index=0&id=2b0176cc&prod&lang=scss&scoped=true"
import style1 from "./InputEvent.vue?vue&type=style&index=1&id=2b0176cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0176cc",
  null
  
)

export default component.exports